/**
 *
 * @module errorCode
 * @see https://github.bamtech.co/sdk-distribution/bam-sdk/blob/master/Features/Error-Handling.mm
 * @see https://github.bamtech.co/sdk-distribution/bam-sdk/blob/master/Features/Error-Handling.md#error-cases
 *
 */

import ExceptionReference from './exceptionReference';

/**
 *
 * @access private
 * @typedef SDK.Services.Exception.ErrorCode
 * @type {Object}
 * @since 3.7.0
 * @desc Internal error code reference object.
 *
 */

/**
 *
 * @type {SDK.Services.Exception.ErrorCode}
 *
 */
export default {
    accountGetFailed: {
        code: 'account.get.failed',
        exceptionData: ExceptionReference.account.accountNotFound
    },
    accountNotFound: {
        code: 'account.not.found',
        exceptionData: ExceptionReference.account.accountNotFound
    },
    accountProfileDeleteFailed: {
        code: 'account.profile.delete.failed',
        exceptionData: ExceptionReference.userProfile.userProfileDeleteFailed
    },
    accountProfileNotFound: {
        code: 'account.profile.not.found',
        exceptionData: ExceptionReference.userProfile.userProfileNotFound
    },
    accountProfileReadFailed: {
        code: 'account.profile.read.failed',
        exceptionData: ExceptionReference.userProfile.profileRetrieval
    },
    accountProfileUpdateFailed: {
        code: 'account.profile.update.failed',
        exceptionData: ExceptionReference.userProfile.userProfileUpdateFailed
    },
    accountProfilesMaxExceeded: {
        code: 'account.profiles.max.exceeded',
        exceptionData: ExceptionReference.userProfile.maximumProfilesReached
    },
    blackout: {
        code: 'blackout',
        exceptionData: ExceptionReference.media.blackout
    },
    clientRevoked: {
        code: 'client-revoked',
        exceptionData: ExceptionReference.media.mediaNotAllowed
    },
    clockSync: {
        code: 'clock-sync',
        exceptionData: ExceptionReference.media.mediaNotAllowed
    },
    copyFailure: {
        code: 'copy.failure',
        exceptionData: ExceptionReference.account.linkSubscriptionPartial
    },
    copyLimitReached: {
        code: 'copy.limit.reached',
        exceptionData: ExceptionReference.account.linkSubscriptionPartial
    },
    idpErrorAttributesUpdateFailed: {
        code: 'idp.error.attributes.update.failed',
        exceptionData: ExceptionReference.bamIdentity.attributeUpdateFailed
    },
    idpErrorIdentityAlreadyExists: {
        code: 'idp.error.identity.already-exists',
        exceptionData: ExceptionReference.bamIdentity.updateIdentityConflict
    },
    idpErrorIdentityBadCredentials: {
        code: 'idp.error.identity.bad-credentials',
        exceptionData: ExceptionReference.bamIdentity.invalidCredentials
    },
    idpErrorPayloadFieldsIncorrect: {
        code: 'idp.error.payload.fields.incorrect',
        exceptionData: ExceptionReference.bamIdentity.invalidEmail
    },
    idpErrorResetTokenAlreadyUsed: {
        code: 'idp.error.reset-token.already-used',
        exceptionData: ExceptionReference.bamIdentity.tokenAlreadyUsed
    },
    idpErrorResetTokenInvalid: {
        code: 'idp.error.reset-token.invalid',
        exceptionData: ExceptionReference.bamIdentity.tokenInvalid
    },
    invalidGrant: {
        code: 'invalid_grant',
        description: ['expired-token'],
        exceptionData: ExceptionReference.common.authenticationExpired
    },
    invalidPasscode: {
        code: 'idp.error.otp.invalid-password',
        exceptionData: ExceptionReference.bamIdentity.invalidPasscode
    },
    loginRequired: {
        code: 'login-required',
        exceptionData: ExceptionReference.media.loginRequired
    },
    mediaMissing: {
        code: 'media.missing',
        exceptionData: ExceptionReference.media.mediaUnavailable
    },
    mediaNotPlayable: {
        code: 'media.not-playable',
        exceptionData: ExceptionReference.media.mediaUnavailable
    },
    notEntitled: {
        code: 'not-entitled',
        exceptionData: ExceptionReference.media.notEntitled
    },
    notPermittedOffline: {
        code: 'not-permitted-offline',
        exceptionData: ExceptionReference.media.offlineNotPermitted
    },
    parentalControl: {
        code: 'parental-control',
        exceptionData: ExceptionReference.media.parentalControls
    },
    payloadFieldsIncorrect: {
        code: 'payload.fields.incorrect',
        exceptionData: ExceptionReference.account.attributeValidation
    },
    payloadIdTokenInvalid: {
        code: 'payload.id-token.invalid',
        exceptionData: ExceptionReference.account.invalidToken
    },
    rateLimited: {
        code: 'idp.error.auth.otp.throttled',
        exceptionData: ExceptionReference.bamIdentity.rateLimited
    },
    securityLevel: {
        code: 'security-level',
        exceptionData: ExceptionReference.media.mediaNotAllowed
    },
    streamConcurrencyViolation: {
        code: 'stream-concurrency-violation',
        exceptionData: ExceptionReference.media.streamConcurrency
    },
    unauthorizedClient: {
        code: 'unauthorized_client',
        description: ['unknown-location', 'unreliable-location', 'forbidden-location'],
        exceptionData: ExceptionReference.common.locationNotAllowed
    },
    unspecifiedDrmError: {
        code: 'unspecified-drm-error',
        exceptionData: ExceptionReference.media.drm
    }
};



// WEBPACK FOOTER //
// ./src/services/exception/errorCode.js